<template>
  <div class="cashback-regra-restricoes">
    <div class="cashback-regra-restricoes__grupos">
      <button
        v-for="grupo in grupos"
        :key="grupo.chave"
        type="button"
        class="cashback-regra-restricoes__grupo"
        :class="{ 'cashback-regra-restricoes__grupo--ativo': grupoAtivo === grupo.chave }"
        :aria-pressed="grupoAtivo === grupo.chave"
        @click="grupoAtivo = grupo.chave"
      >
        <span class="cashback-regra-restricoes__grupo-icone"><fa-icon :icon="grupo.icone" /></span>
        <span class="cashback-regra-restricoes__grupo-texto">
          <span class="cashback-regra-restricoes__grupo-titulo">{{ grupo.titulo }}</span>
          <span class="cashback-regra-restricoes__grupo-status">{{ statusDo(grupo) }}</span>
        </span>
      </button>
    </div>

    <div v-for="grupo in grupos" v-show="grupoAtivo === grupo.chave" :key="grupo.chave" class="cashback-regra-restricoes__conteudo">
      <div class="cashback-regra__secao-titulo">{{ grupo.titulo }}</div>
      <p class="cashback-regra-restricoes__descricao">{{ grupo.descricao }}</p>
      <p v-if="grupo.regra" class="cashback-regra-restricoes__regra">
        <fa-icon icon="info-circle" class="mr-1" />{{ grupo.regra }}
      </p>
      <RestricoesCashback
        :value="item.restricoes"
        :tipos="opcoes[grupo.opcao]"
        :valores="valores"
        :dimensoes="grupo.chave === 'produto' ? dimensoes : []"
        :vazio="grupo.vazio"
        :sujeito="grupo.sujeito"
        :exige-todas="grupo.exigeTodas"
        @input="$emit('alterar', { restricoes: $event })"
      />
    </div>
  </div>
</template>

<script>
import RestricoesCashback from "../components/RestricoesCashback.vue";

export default {
  name: "StepRestricoes",
  components: { RestricoesCashback },

  props: {
    item: { type: Object, required: true },
    opcoes: { type: Object, required: true },
    valores: { type: Object, default: () => ({}) },
    dimensoes: { type: Array, default: () => [] },
  },

  data() {
    return {
      grupoAtivo: "produto",
      grupos: [
        {
          chave: "produto",
          opcao: "restricoesProduto",
          icone: "cubes",
          titulo: "Base de cálculo",
          descricao:
            "Só os itens que se encaixam em algum destes filtros entram na base do cashback. Sem filtros, vale o pedido inteiro.",
          vazio: "Sem filtro de produtos: todos os itens do pedido entram na base do cashback.",
          sujeito: "O item entra na base quando se encaixa em",
          exigeTodas: false,
        },
        {
          chave: "cliente",
          opcao: "restricoesCliente",
          icone: "users",
          titulo: "Participantes",
          descricao: "Restrinja os clientes que ganham cashback. Sem restrições, todos participam.",
          vazio: "Sem restrição de clientes: todos participam.",
          sujeito: "O cliente participa quando atende",
          exigeTodas: true,
        },
        {
          chave: "condicao",
          opcao: "restricoesCondicao",
          icone: "file-invoice-dollar",
          titulo: "Condições comerciais",
          descricao:
            "Limite a regra a operações, cobranças, planos de pagamento, operadores, representantes, supervisores ou gerentes do pedido.",
          regra: "Estas condições são exigidas junto com as de Participantes: o pedido precisa atender às duas.",
          vazio: "Sem restrição: vale para qualquer operação, cobrança, plano de pagamento e vendedor.",
          sujeito: "A regra vale para o pedido quando ele atende",
          exigeTodas: true,
        },
      ],
    };
  },

  methods: {
    quantidadeDo(grupo) {
      const tipos = (this.opcoes[grupo.opcao] || []).map((tipo) => tipo.chave);

      return this.item.restricoes.filter((restricao) => tipos.includes(restricao.tipo)).length;
    },

    statusDo(grupo) {
      const quantidade = this.quantidadeDo(grupo);

      if (!quantidade) return grupo.vazio;

      return quantidade === 1 ? "1 restrição" : `${quantidade} restrições`;
    },
  },
};
</script>

<style scoped>
.cashback-regra__secao-titulo {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  color: #888;
  letter-spacing: 0.5px;
  margin-bottom: 4px;
}

.cashback-regra-restricoes__grupos {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
  margin-bottom: 16px;
}

.cashback-regra-restricoes__grupo {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border: 1px solid #e4e7eb;
  border-radius: 10px;
  background: #fff;
  text-align: left;
  cursor: pointer;
  transition: all 0.15s ease;
}

.cashback-regra-restricoes__grupo:hover {
  border-color: #c5c8cc;
  background-color: #fafafa;
}

.cashback-regra-restricoes__grupo--ativo {
  border-color: var(--cashback-cor-primaria);
  background-color: var(--cashback-cor-primaria-suave);
}

.cashback-regra-restricoes__grupo-icone {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  background-color: #f2f2f8;
  color: var(--cashback-cor-primaria);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cashback-regra-restricoes__grupo--ativo .cashback-regra-restricoes__grupo-icone {
  background-color: #dddce9;
}

.cashback-regra-restricoes__grupo-texto {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.cashback-regra-restricoes__grupo-titulo {
  font-size: 13px;
  font-weight: 600;
  color: #2c2c2c;
}

.cashback-regra-restricoes__grupo-status {
  font-size: 11px;
  color: #777;
}

.cashback-regra-restricoes__descricao {
  font-size: 12px;
  color: #667085;
  margin-bottom: 4px;
}

.cashback-regra-restricoes__regra {
  font-size: 12px;
  color: #2298a3;
  margin-bottom: 12px;
}

@media (max-width: 768px) {
  .cashback-regra-restricoes__grupos {
    grid-template-columns: 1fr;
  }
}
</style>
